import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ColorComponent} from '../color/color.component';

@Component({
  selector: 'app-background',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    ColorComponent
  ],
  templateUrl: './background.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './background.component.scss'
})
export class BackgroundComponent extends AbstractStyleComponent {
  @ViewChild('color') colorComponent!: ColorComponent;

  getValue(): any {
    return {
      color: this.colorComponent.getValue(),
    }
  }

  setValue(value: any): void {
    this.colorComponent.setValue(value['color']);
  }
}
